import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/client';

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingId, setSendingId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/campaigns').then((res) => setCampaigns(res.data)).finally(() => setLoading(false));
  }, []);

  const sendCampaign = async (c) => {
    if (!window.confirm(`Enviar la campana "${c.nombre}" ahora?`)) return;
    setSendingId(c.id);
    try {
      await api.post(`/campaigns/${c.id}/send`);
      navigate(`/campaigns/${c.id}/dashboard`);
    } catch (err) {
      alert(err.response?.data?.error || 'Error al enviar la campana');
      setSendingId(null);
    }
  };

  const cancelCampaign = async (c) => {
    if (!window.confirm(`Detener la campana "${c.nombre}"? Los mensajes ya enviados no se recuperan, solo se cancelan los pendientes.`)) return;
    try {
      const { data } = await api.post(`/campaigns/${c.id}/cancel`);
      alert(data.message);
      api.get('/campaigns').then((res) => setCampaigns(res.data));
    } catch (err) {
      alert(err.response?.data?.error || 'Error al detener la campana');
    }
  };

  const estadoColor = { borrador: '#888', programada: '#3498db', enviando: '#f39c12', enviada: '#2ecc71', cancelada: '#e74c3c' };

  if (loading) return <div>Cargando...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h1>Campanas</h1>
        <button
          onClick={() => navigate('/campaigns/new')}
          style={{ padding: '10px 24px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 14 }}
        >
          + Nueva Campana
        </button>
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
              <th style={{ padding: 12 }}>Nombre</th>
              <th>Tipo</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.map((c) => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={{ padding: 12 }}>{c.nombre}</td>
                <td>{c.tipo}</td>
                <td>
                  <span style={{
                    padding: '3px 10px', borderRadius: 12, fontSize: 11,
                    background: `${estadoColor[c.estado]}20`, color: estadoColor[c.estado],
                  }}>
                    {c.estado}
                  </span>
                </td>
                <td>{new Date(c.createdAt).toLocaleDateString()}</td>
                <td>
                  <Link to={`/campaigns/${c.id}/dashboard`} style={{ color: '#4ecca3', marginRight: 12, fontSize: 12 }}>
                    Ver metricas
                  </Link>
                  {(c.estado === 'borrador' || c.estado === 'programada') && (
                    <button onClick={() => navigate(`/campaigns/${c.id}/edit`)} style={{
                      background: 'none', border: 'none', color: '#f39c12', cursor: 'pointer', fontSize: 12, padding: 0, marginRight: 12,
                    }}>Editar</button>
                  )}
                  {(c.estado === 'borrador' || c.estado === 'programada') && (
                    <button
                      onClick={() => sendCampaign(c)}
                      disabled={sendingId === c.id}
                      style={{
                        background: 'none', border: 'none', color: '#2ecc71', cursor: sendingId === c.id ? 'wait' : 'pointer',
                        fontSize: 12, padding: 0, marginRight: 12, fontWeight: 600,
                      }}>{sendingId === c.id ? 'Enviando...' : 'Enviar ahora'}</button>
                  )}
                  {(c.estado === 'enviando' || c.estado === 'programada') && (
                    <button onClick={() => cancelCampaign(c)} style={{
                      background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer',
                      fontSize: 12, padding: 0, marginRight: 12, fontWeight: 600,
                    }}>⏹ Detener</button>
                  )}
                  <button onClick={() => navigate(`/campaigns/new?duplicate=${c.id}`)} style={{
                    background: 'none', border: 'none', color: '#3498db', cursor: 'pointer', fontSize: 12, padding: 0,
                  }}>Duplicar</button>
                </td>
              </tr>
            ))}
            {campaigns.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 30, textAlign: 'center', color: '#888' }}>No hay campanas aun</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
